import { render, staticRenderFns } from "./discountCoupon.vue?vue&type=template&id=331e9ee4&scoped=true&"
import script from "./discountCoupon.vue?vue&type=script&lang=js&"
export * from "./discountCoupon.vue?vue&type=script&lang=js&"
import style0 from "./discountCoupon.vue?vue&type=style&index=0&id=331e9ee4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e9ee4",
  null
  
)

export default component.exports